import { CustomerDPApiError } from './customer-dp.errors';
import { createAction, props } from '@ngrx/store';
import { BlendState } from 'src/app/shared/types/blend-state.type';

export const CollectDnaButtonClicked = createAction(
  '[Customer DP] Collect DNA Button Clicked',
  props<{ dpId: string }>(),
);

export const LoadBlendStateSucceeded = createAction(
  '[Customer DP] Load Blend State Successful',
  props<{ blendState: BlendState }>(),
);

export const LoadBlendStateErrored = createAction(
  '[Customer DP] Load Blend State Error',
  props<{ error: CustomerDPApiError }>(),
);

export const RemoveCustomerDPError = createAction('[Customer DP] Remove Customer DP Error');

export const ProjectCollectDnaDialogOpened = createAction(
  '[Customer DP] Collect DNA Dialog Opened',
);
